<template>
  <div id="app">
    <!-- 顶部Logo和二维码区域 -->
    <div class="header-container">
      <div class="logo-container">
        <img src="@/assets/guirenzhenzhushalog.jpg" alt="企业logo" class="logo" />
      </div>
      <!-- <div class="qrcode-container">
        <img src="http://ss472xqcz.hn-bkt.clouddn.com/qrcode.jpg" alt="二维码" class="qrcode" />
      </div> -->
    </div>
    <!-- 内容区域 -->
    <router-view></router-view>
  </div>
</template>

<script setup>

</script>

<style scoped>
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 20px;
  background-color: #fff;
  z-index: 100;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.logo-container {
  flex: 1;
}

.logo {
  height: 60px;
  width: auto;
  object-fit: contain;
}

.qrcode-container {
  margin-left: 25px;
}

.qrcode {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 可以在这里添加全局样式 */
</style>
